/* eslint-disable import/first */
/* ============
 * Main File
 * ============
 *
 * Will initialize the application.
 */
// import './app/polyfills'

import Vue from 'vue'

/* ============
 * Plugins
 * ============
 *
 * Import and bootstrap the plugins.
 */
import '@/app/plugins/vuex'
import '@/app/plugins/axios'
import { i18n } from '@/app/plugins/vue-i18n'
import { router } from '@/app/plugins/vue-router'
import '@/app/plugins/vuex-router-sync'
import '@/app/plugins/auth'
import '@/app/plugins/storage'
import '@/app/plugins/api'
import '@/app/plugins/vue-shortkey'
import '@/app/plugins/vue-acl'
import '@/app/plugins/vue-bem-cn'
import '@/app/plugins/vue-meta'
import '@/app/plugins/v-media-query'
import '@/app/plugins/element'
import '@/app/plugins/contentful'
// import '@/app/plugins/vue-datatables'
// import '@/app/plugins/vue-full-calendar'
// import '@/app/plugins/vue-rx'

require('fullcalendar/dist/fullcalendar.css')
import '@/app/plugins/vee-validate'
import '@/app/plugins/v-autocomplete'
import '@/app/plugins/algoliasearch'
import '@/app/plugins/helpers'
import '@/app/plugins/vue-breadcrumbs'

/* ============
 * Filters
 * ============
 *
 * Import and install helpers for filters.
 */
import { domain, count, prettyDate, pluralize, round, truncate, md } from './app/filters'

Vue.filter('count', count)
Vue.filter('domain', domain)
Vue.filter('prettyDate', prettyDate)
Vue.filter('pluralize', pluralize)
Vue.filter('round', round)
Vue.filter('truncate', truncate)
Vue.filter('md', md)
require('@/app/directives')

/* ============
 * Metronic
 * ============
 *
 * Import Metronic styles
 */
// Global
require('@/app/assets/scss/metronic/bootstrap.scss')
require('@/app/assets/scss/metronic/global/components.scss')
require('@/app/assets/scss/metronic/global/components-md.scss')
require('@/app/assets/scss/metronic/global/components-rounded.scss')
require('@/app/assets/scss/metronic/global/plugins.scss')
// Pages
require('@/app/assets/scss/metronic/pages/profile.scss')
// Layout & theme
require('@/app/assets/scss/metronic/layouts/layout/layout.scss')
require('@/app/assets/scss/metronic/layouts/layout/themes/darkblue.scss')

/* ============
 * Font Awesome Icons
 * ============
 *
 * Import font-awesome icons.
 */
require('font-awesome/css/font-awesome.css')

/* ============
 * Simple Line Icons
 * ============
 *
 * Import simple-line icons.
 */
require('simple-line-icons/css/simple-line-icons.css')

/* ============
 * Datatables
 * ============
 *
 * Import datatables related files.
 */
require('datatables.net-bs')
require('datatables.net-bs/css/dataTables.bootstrap.css')
require('datatables.net-buttons-bs')
require('datatables.net-buttons/js/buttons.print')
require('datatables.net-buttons/js/buttons.html5')
require('datatables.net-buttons/js/buttons.flash')
require('datatables.net-buttons-bs/css/buttons.bootstrap.css')
require('datatables.net-responsive-bs')
require('datatables.net-responsive-bs/css/responsive.bootstrap.css')
require('datatables.net-buttons/js/buttons.colVis.js')
require('datatables.net-fixedcolumns')
require('datatables.net-fixedcolumns-dt/css/fixedColumns.dataTables.css')

/* ============
 * Vue-Multiselect CSS
 * ============
 *
 * Import vue-multiselect styles.
 */
require('vue-multiselect/dist/vue-multiselect.min.css')

/* ============
 * Custom Application Styling
 * ============
 *
 * Import the application styling.
 */
require('@/app/assets/scss/app.scss')

/* ============
 * Main App
 * ============
 *
 * Last but not least, we import the main application.
 */
import App from '@/app/App'
import store from '@/app/store'

Vue.config.productionTip = false

store.dispatch('auth/check').then(() => {
  /* eslint-disable no-new */
  new Vue({
    /**
     * Bind the Vue instance to the HTML.
     */
    el: '#app',

    /**
     * The localization plugin.
     */
    i18n,

    /**
     * The router.
     */
    router,

    /**
     * The Vuex store.
     */
    store,

    /**
     * Will render the application.
     *
     * @param {Function} h Will create an element.
     */
    render: h => h(App)
  })
})
  .catch(err => console.log(err))



// WEBPACK FOOTER //
// ./src/main.js